import PencilIcon from "../../../public/assets/pencil.svg";

export default PencilIcon;
